{
  "var": {
    "value": "es"
  },
  "page_Attendent_ABit": {
    "value": "Un poco de mi experiencia"
  },
  "page_Attendent_BasicInfo": {
    "value": "Información Básica"
  },
  "page_Attendent_ChangeModal": {
    "value": "Cualquier cambio de perfil debe revisarse y puede demorar hasta 3 días hábiles antes de que esté disponible para el público. Recibirá un correo electrónico cuando sus cambios hayan sido aprobados."
  },
  "page_Attendent_ContactInfo": {
    "value": "Use nuestro servicio de mensajería para contactar al asistente de manera segura"
  },
  "page_Attendent_DateQuickSelect": {
    "value": "Selección Rápida de Fecha"
  },
  "page_Attendent_DeleteModal": {
    "value": "La eliminación de su perfil es permanente. Su perfil será eliminado del directorio y ya no podrá acceder a él. ¿Está seguro de que desea eliminar su perfil?"
  },
  "page_Attendent_EmailUpdated": {
    "value": "Correo Electrónico Actualizado Con Exito"
  },
  "page_Attendent_EnterYourEmail": {
    "value": "Escribe un breve mensaje expresando tu interés. Ingrese su dirección de correo electrónico y presione el botón Enviar mensaje. El directorio de proveedores enviará este mensaje con su dirección de correo electrónico al destinatario."
  },
  "page_Attendent_HearAbout": {
    "value": "¿Cómo te enteraste de nosotros?"
  },
  "page_Attendent_Hello": {
    "value": "Hola"
  },
  "page_Attendent_Maximum": {
    "value": "Distancia Máxima de Viaje"
  },
  "page_Attendent_MessageSent_title": {
    "value": "Mensaje Enviado"
  },
  "page_Attendent_MessageSent_p1": {
    "value": "Se ha enviado un correo electrónico al asistente con su mensaje. Si el asistente cree que es una buena pareja, se pondrá en contacto con su dirección de correo electrónico."
  },
  "page_Attendent_MoreAbout": {
    "value": "Más información sobre mi experiencia laboral"
  },
  "page_Attendent_WorkExperience": {
    "value": "Experiencia Laboral"
  },
  "page_Attendent_WorkEnvironmentPref": {
    "value": "Preferencias del Entorno de Trabajo"
  },
  "page_Attendent_PersonalSummaryInfo": {
    "value": "Su resumen personal se muestra cuando se encuentra en una búsqueda de asistente"
  },
  "page_Attendent_PetHousehold": {
    "value": "Hogar de Mascotas"
  },
  "page_Attendent_PreferredStartingDate": {
    "value": "Fecha de Inicio Preferida"
  },
  "page_Attendent_ProfileStatusInfo": {
    "value": "Configure su perfil como inactivo para que ya no aparezca en las búsquedas de los asistentes"
  },
  "page_Attendent_ProviderServices": {
    "value": "Servicios Del Proveedor"
  },
  "page_Attendent_SmokingHousehold": {
    "value": "Fumar en el Hogar"
  },
  "page_Attendent_Availability": {
    "value": "Disponibilidad"
  },
  "page_Attendent_WeeklyWorkPreference": {
    "value": "Seleccione todas las horas en las que preferiría trabajar"
  },
  "page_Attendent_ClientPreferences": {
    "value": "Preferencias del Cliente"
  },
  "page_Attendent_YearsExperience": {
    "value": "Años de Experiencia Brindando Cuidado Personal"
  },
  "page_Attendant_Reaffirm_Success": {
    "value": "Ha confirmado su cuenta y ahora seguirá apareciendo en los resultados de búsqueda. ¡Gracias!"
  },
  "page_Attendant_Reaffirm_Failure": {
    "value": "Algo salió mal, por favor póngase en contacto con soporte"
  },
  "page_AttendantAffirm_PasswordReset": {
    "value": "Establezca su contraseña en la página siguiente."
  },
  "page_AttendantAffirm_Success": {
    "value": "Perfil Actualizado Con Exito, Gracias!"
  },
  "page_HomeCO_BecomeAttendant": {
    "value": "CONVIÉRTETE EN UN ASISTENTE"
  },
  "page_HomeCO_Description": {
    "value": "Consumer Direct Colorado se ha asociado con Colorado Department of Health Care Policy and Financing para desarrollar una red para conectar a los empleadores con posibles asistentes de CDASS."
  },
  "page_HomeCO_FindAnAttendant": {
    "value": "ENCUENTRE UN ASISTENTE"
  },
  "page_HomeCO_Paragraph1": {
    "value": "Los Servicios de apoyo de asistente dirigidos por el consumidor (CDASS) son una opción en Colorado que permite a las personas autodirigir sus servicios. Un individuo, que puede ser una persona discapacitada o anciana y elige participar en CDASS, es el empleador legal registrado. Como empleadores, las personas contratan, capacitan y administran a los asistentes de su elección que mejor se adaptan a sus necesidades únicas."
  },
  "page_HomeCO_Paragraph2": {
    "value": "La misión de Consumer Direct es brindar servicios de calidad a los empleadores para que puedan permanecer en sus hogares y comunidades. Nos esforzamos por brindar un excelente servicio al cliente y herramientas simples que respalden el éxito en la gestión de asistentes. El Directorio de Asistentes es una herramienta para ayudar a los empleadores a conectarse con asistentes que puedan apoyarlos con su calidad de vida en su hogar y comunidad."
  },
  "page_HomeCO_Paragraph3": {
    "value": "Los empleadores que buscan asistentes en el directorio eligen si quieren entrevistar y contratar a un asistente potencial. Esto incluye determinar si las habilidades y la experiencia del asistente potencial son adecuadas."
  },
  "page_HomeCO_FindAttendants": {
    "value": "Localiza a los asistentes en tu zona."
  },
  "page_HomeCO_Requirements_Paragraph": {
    "value": "Todos los asistentes potenciales que buscan trabajo o los asistentes actuales que buscan horas adicionales con otros empleadores deben registrarse para utilizar el Directorio de asistentes. Tenga en cuenta que se requiere completar el proceso de empleo con el proveedor de servicios de administración financiera (FMS) seleccionado por el empleador."
  },
  "page_HomeCO_Requirements_p1": {
    "value": "Haga clic "
  },
  "page_HomeCO_Requirements_p2": {
    "value": "AQUI"
  },
  "page_HomeCO_Requirements_p3": {
    "value": " para obtener requisitos para unirse."
  },
  "page_HomeCO_Title": {
    "value": "Directorio de asistente de CDASS"
  },
  "page_HomeCO_Trademark": {
    "value": "© 2021 CDASS Attendant Directory es una marca registrada de Consumer Direct Management Solutions, Inc."
  },
  "page_Home_Title": {
    "value": "Consumer Direct Care Network (CDCN) Provider Directory"
  },
  "page_Home_p1": {
    "value": "Bienvenido al Directorio de proveedores de Consumer Direct Care Network (CDCN). Esta herramienta gratuita conecta a los beneficiarios de los servicios de CDCN con quienes buscan empleo y buscan una carrera en el campo del cuidado."
  },
  "page_Home_p2": {
    "value": "Buscadores de Empleo"
  },
  "page_Home_p3": {
    "value": "¿Interesado en una carrera en el campo del cuidado? Regístrese con nosotros. Creará un perfil en línea que destaque su experiencia, cualidades e intereses. Después de completar su perfil, las personas que buscan atención pueden comunicarse con usted acerca de las oportunidades de atención."
  },
  "page_Home_p4": {
    "value": "Destinatarios del Servicio"
  },
  "page_Home_p5": {
    "value": "Use este directorio para ayudarlo a encontrar un cuidador en su área. Tenga en cuenta que CDCN no examina ningún perfil en el Directorio de proveedores. CDCN no asume ninguna responsabilidad por la exactitud o confiabilidad de la información proporcionada por los cuidadores."
  },
  "page_Home_p6": {
    "value": "Para obtener más información sobre CDCN y nuestros servicios, visite "
  },
  "page_Home_p7": {
    "value": "ConsumerDirectCare.com."
  },
  "page_Home_FindACaregiver": {
    "value": "ENCUENTRA UN CUIDADOR"
  },
  "page_Home_BecomeCaregiver": {
    "value": "CONVIÉRTETE EN CUIDADOR"
  },
  "page_Home_FindCaregivers": {
    "value": "Encuentre cuidadores en su zona."
  },
  "page_Home_DisclaimerL1": {
    "value": "El Provider Directory ayuda a las personas a encontrar cuidadores. Consumer Direct Care Network no:"
  },
  "page_Home_DisclaimerL2": {
    "value": "Verificar o aprobar perfiles de cuidadores."
  },
  "page_Home_DisclaimerL3": {
    "value": "Verifique si el cuidador puede brindar cuidados."
  },
  "page_Home_DisclaimerL4": {
    "value": "Los cuidadores no pueden prestar servicios de inmediato. Deben ser contratados y autorizados previamente."
  },
  "page_Home_GetConnected": {
    "value": "Conéctate como cuidador"
  },
  "page_Home_GetConnectedCO": {
    "value": "Conéctate como asistente"
  },
  "page_Home_Hero_Title": {
    "value": "CONEXIONES DE ATENCIÓN DOMICILIARIA"
  },
  "page_Home_JoinOurNetwork": {
    "value": "Únete a nuestra red"
  },
  "link_SkipToMainContent": {
    "value": "Saltar al contenido principal"
  },
  "page_Home_Radius": {
    "value": "Radio"
  },
  "page_Home_SearchInfo": {
    "value": "Ingrese el ZipCode donde desea recibir atención y luego elija la distancia alrededor del código postal que desea encontrar proveedores de atención propectiva. Haga clic en el botón Búsqueda para encontrar todos los proveedores aplicables."
  },
  "page_Home_SearchInfoCO": {
    "value": "Ingrese el ZipCode donde desea recibir atención y luego elija la distancia alrededor del ZipCode que le gustaría encontrar asistentes propectivos. Haga clic en el botón de búsqueda para encontrar todos los asistentes aplicables."
  },
  "page_Home_Terms_title": {
    "value": "Términos y Condiciones"
  },
  "page_Home_Terms": {
    "value": "Provider Directory no es responsable del contenido de los mensajes enviados entre posibles proveedores y clientes. El directorio de proveedores supervisa el contenido del perfil, pero no el contenido del mensaje."
  },
  "page_Home_Trademark": {
    "value": "© El directorio de proveedores de Consumer Direct Care Network (CDCN) es una marca registrada de Consumer Direct Management Solutions, Inc."
  },
  "page_Home_Terms_view": {
    "value": "Ver Términos y Condiciones Completos"
  },
  "page_Home_Requirements_Paragraph": {
    "value": "Marca la diferencia en tu comunidad."
  },
  "page_Home_TC_1": {
    "value": "Última actualización: 1/6/2026"
  },
  "page_Home_TC_2": {
    "value": "Bienvenido al Directorio de Proveedores (“el Sitio”), un directorio en línea operado por Consumer Direct Care Network (“nosotros,” “nuestro,” o “nos”). Al acceder o usar este Sitio, usted acepta estos Términos y Condiciones (“Términos”). Si no está de acuerdo, por favor deje de usarlo inmediatamente."
  },
  "page_Home_TC_3": {
    "value": "1. Propósito del Sitio"
  },
  "page_Home_TC_4": {
    "value": "Este Sitio sirve como un directorio de proveedores de atención médica y servicios relacionados. Está destinado únicamente a fines informativos para ayudar a los usuarios a identificar y conectarse con proveedores. El Sitio no proporciona asesoramiento médico, diagnósticos ni tratamientos. Siempre debe consultar a un profesional de la salud calificado para asuntos médicos."
  },
  "page_Home_TC_5": {
    "value": "2. Uso del Sitio"
  },
  "page_Home_TC_6": {
    "value": "Puede usar este Sitio solo para fines legales, incluyendo ver listados de proveedores y enviar solicitudes legítimas de información. Usted acepta no usar el Sitio para minería de datos no autorizada, envío de correo no deseado, o cualquier actividad que interrumpa las operaciones del Sitio o comprometa la privacidad de los usuarios."
  },
  "page_Home_TC_7": {
    "value": "3. Envío de Información Personal y de Salud"
  },
  "page_Home_TC_8": {
    "value": "Cuando envía una solicitud a través de nuestro portal, es posible que se le solicite proporcionar información de identificación personal (PII) y, en algunos casos, información limitada de salud protegida (PHI), como información sobre sus necesidades o preferencias de atención médica. Al enviar esta información, usted consiente su recopilación, uso y divulgación como se describe a continuación y en nuestra Política de Privacidad."
  },
  "page_Home_TC_9": {
    "value": "Usted acepta que:"
  },
  "page_Home_TC_10": {
    "value": "La información que proporciona es verdadera, precisa y completa."
  },
  "page_Home_TC_11": {
    "value": "La información que usted envía puede ser transmitida de manera segura a proveedores seleccionados para facilitar el contacto y la coordinación de servicios."
  },
  "page_Home_TC_12": {
    "value": "Usted es responsable de evitar enviar más detalles médicos de los necesarios para iniciar el contacto."
  },
  "page_Home_TC_13": {
    "value": "4. Cumplimiento de HIPAA y Privacidad de Datos"
  },
  "page_Home_TC_14": {
    "value": "Estamos comprometidos a proteger su privacidad en cumplimiento con la Ley de Portabilidad y Responsabilidad de Seguros de Salud de 1996 (HIPAA) y las leyes estatales de privacidad aplicables."
  },
  "page_Home_TC_15": {
    "value": "Implementamos salvaguardas administrativas, técnicas y físicas para proteger la PII y PHI contra el acceso o divulgación no autorizados."
  },
  "page_Home_TC_16": {
    "value": "La información enviada a través del Sitio se cifra en tránsito y se almacena de forma segura."
  },
  "page_Home_TC_17": {
    "value": "El acceso a la PII/PHI está restringido al personal autorizado que requiere los datos para realizar sus funciones laborales."
  },
  "page_Home_TC_18": {
    "value": "Cuando la información se comparte con los proveedores, se hace únicamente con el propósito de facilitar el tratamiento, la coordinación de la atención o la comunicación iniciada por usted."
  },
  "page_Home_TC_19": {
    "value": "Una vez que su información se transmite a un proveedor, ese proveedor se vuelve responsable de protegerla bajo sus propias obligaciones de HIPAA."
  },
  "page_Home_TC_20": {
    "value": "5. Precisión de la Información del Proveedor"
  },
  "page_Home_TC_21": {
    "value": "Los listados de proveedores y la información relacionada se mantienen lo mejor posible. Sin embargo, los proveedores son responsables de mantener su información actualizada. No podemos garantizar la integridad o exactitud de las entradas del directorio y no somos responsables de errores o información desactualizada."
  },
  "page_Home_TC_22": {
    "value": "6. No Relación Médica"
  },
  "page_Home_TC_23": {
    "value": "Enviar información a través del Sitio no establece una relación médica, paciente-proveedor o empleador con Consumer Direct Care Network. No controlamos las prácticas, servicios o decisiones de los proveedores listados."
  },
  "page_Home_TC_24": {
    "value": "7. Propiedad Intelectual"
  },
  "page_Home_TC_25": {
    "value": "Todo el contenido del Sitio, incluidos los listados de proveedores, elementos de diseño y texto, es propiedad de o está licenciado a Consumer Direct Care Network y está protegido por leyes de propiedad intelectual. No puede reproducir ni distribuir el contenido del Sitio sin permiso por escrito."
  },
  "page_Home_TC_26": {
    "value": "8. Renuncia de Garantías"
  },
  "page_Home_TC_27": {
    "value": "El Sitio y todo su contenido se proporcionan “tal cual” sin garantía de ningún tipo, expresa o implícita. Consumer Direct Care Network no garantiza la disponibilidad, el rendimiento o la calidad del servicio de los proveedores."
  },
  "page_Home_TC_28": {
    "value": "9. Limitación de Responsabilidad"
  },
  "page_Home_TC_29": {
    "value": "En la máxima medida permitida por la ley, Consumer Direct Care Network no es responsable de ningún daño indirecto, incidental o consecuente que resulte del uso del Sitio, la confianza en su contenido o cualquier interacción con los proveedores listados."
  },
  "page_Home_TC_30": {
    "value": "10. Actualizaciones de los Términos"
  },
  "page_Home_TC_31": {
    "value": "Podemos modificar estos Términos de vez en cuando. Cualquier actualización se publicará en esta página con una nueva fecha de “Última Actualización”. El uso continuado del Sitio constituye su aceptación de los Términos revisados."
  },
  "page_Home_TC_32": {
    "value": "11. Información de Contacto"
  },
  "page_Home_TC_33": {
    "value": "Para consultas sobre privacidad o cumplimiento, por favor contacte a:"
  },
  "page_Home_TC_34": {
    "value": "Oficial de Privacidad: Holly Stephens"
  },
  "page_Home_TC_35": {
    "value": "Correo electrónico: "
  },
  "page_Register_Hero_Title": {
    "value": "Conviértete en Cuidador"
  },
  "page_Register_Hero_TitleCO": {
    "value": "Conviértete en Asistente"
  },
  "page_Register_Hero_Join": {
    "value": "ÚNETE A NUESTRA RED"
  },
  "page_Register_Title": {
    "value": "¿Interesado en una carrera en el campo del cuidado?"
  },
  "page_Register_steps": {
    "value": "Simplemente crea un perfil en línea donde destaques tu experiencia, cualidades e intereses. Una vez que hayas completado tu perfil, las personas que buscan cuidadores podrán contactarte para ofrecerte oportunidades de trabajo."
  },
  "page_Register_Title_CO": {
    "value": "Únase al Directorio de Asistentes"
  },
  "page_Register_EasyStepsTitle_CO": {
    "value": "Pasos sencillos para Empezar"
  },
  "page_Register_EasySteps_p1_CO": {
    "value": "Lea y acepte los Términos y Condiciones"
  },
  "page_Register_EasySteps_p2_CO": {
    "value": "Complete el formulario de registro y haga clic en CREATE"
  },
  "page_Register_EasySteps_p3_CO": {
    "value": "Complete su Perfil de Directorio"
  },
  "page_Register_EasySteps_p4_CO": {
    "value": "Comience a conectarse con clientes potenciales que buscan atención en su área"
  },
  "page_Register_EasySteps_p5_CO": {
    "value": "Una vez que haya completado su perfil, los clientes potenciales pueden revisar su información y enviarle un mensaje si es adecuado para sus necesidades."
  },
  "page_Register_AlreadySignedIn": {
    "value": "Ya ha iniciado sesión.  Debes cerrar la sesión antes de registrar una nueva cuenta."
  },
  "page_Requirements_CDASS_title": {
    "value": "Consumer Direct Attendant Support Services (CDASS)"
  },
  "page_Requirements_CDASS_p1": {
    "value": "CDASS es una opción de servicio de Medicaid bajo el Programa de Servicios Basados en el Hogar y la Comunidad. CDASS permite a los empleadores dirigir sus propias necesidades de atención en lugar de pasar por una agencia tradicional de atención médica en el hogar. Las personas que eligen participar en CDASS son los empleadores legales registrados para los asistentes que eligen contratar."
  },
  "page_Requirements_CDASS_p2": {
    "value": "Bajo CDASS, el empleador es responsable de capacitar, supervisar y programar a los asistentes a su propia discreción para satisfacer sus necesidades. El empleador puede fijar los salarios de los asistentes dentro de su presupuesto mensual y decidir dónde y cuándo reciben los servicios. Un proveedor de FMS elegido por el empleador ayudará con los impuestos, la nómina, el papeleo, la verificación de antecedentes y la selección de los asistentes que el empleador elija contratar."
  },
  "page_Requirements_CDASS_p3": {
    "value": "Para acceder a los servicios de CDASS y averiguar si califica,"
  },
  "page_Requirements_CDASS_p4": {
    "value": "comuníquese con la agencia de Single Entry Point en su área."
  },
  "page_Requirements_CDASS_p5": {
    "value": "Para obtener más información sobre CDASS, haga clic en los logotipos a continuación"
  },
  "page_Requirements_Employed_title": {
    "value": "Ser empleado como asistente de cuidador bajo CDASS"
  },
  "page_Requirements_Employed_p1": {
    "value": "En el programa CDASS, hay ciertos criterios que los asistentes potenciales deben cumplir para ser contratados, que incluyen"
  },
  "page_Requirements_Employed_p2": {
    "value": "Pasar los antecedentes penales y los controles de la Junta de Enfermería"
  },
  "page_Requirements_Employed_p3": {
    "value": "Pasar un cheque de la Oficina del Inspector General (OIG)"
  },
  "page_Requirements_Employed_p4": {
    "value": "Autorización para trabajar en los Estados Unidos (Formulario I-9)"
  },
  "page_Requirements_Employed_p5": {
    "value": "El proveedor de FMS seleccionado por el empleador proporcionará toda la documentación de empleo necesaria y facilitará el cumplimiento de todos los criterios."
  },
  "page_Requirements_Employed_p6": {
    "value": "Tenga en cuenta"
  },
  "page_Requirements_Employed_p7": {
    "value": "Los asistentes no serán aprobados ni utilizados para el empleo si alguna vez son condenados por los siguientes delitos dentro de cualquier período de tiempo"
  },
  "page_Requirements_Employed_p8": {
    "value": "Secuestro"
  },
  "page_Requirements_Employed_p9": {
    "value": "Cualquier delito grave violento (incluidos, entre otros, violación, agresión sexual, homicidio, agresión física criminal o agresión criminal)"
  },
  "page_Requirements_Employed_p10": {
    "value": "Abuso o negligencia de niños/adultos"
  },
  "page_Requirements_Employed_p11": {
    "value": "Delitos que implican la explotación de un niño o de un adulto incapacitado"
  },
  "page_Requirements_Employed_p12": {
    "value": "Delito grave relacionado con un acto de violencia doméstica"
  },
  "page_Requirements_Employed_p13": {
    "value": "Incendio premeditado"
  },
  "page_Requirements_Employed_p14": {
    "value": "Delito grave o delito menor contra un niño o adulto incapacitado que causa daño"
  },
  "page_Requirements_Employed_p15": {
    "value": "Robo de delito grave"
  },
  "page_Requirements_Employed_p16": {
    "value": "Crímenes de odio"
  },
  "page_Requirements_Employed_p17": {
    "value": "Fraude (incluido, entre otros, robo de identidad, falsificación, fraude financiero o fraude de atención médica)"
  },
  "page_Requirements_Employed_p18": {
    "value": "Secuestro"
  },
  "page_Requirements_Employed_p19": {
    "value": "Asesinato/homicidio"
  },
  "page_Requirements_Employed_p20": {
    "value": "Negligencia o abuso por parte de un cuidador"
  },
  "page_Requirements_Employed_p21": {
    "value": "Delitos de pornografía que involucran a niños o adultos incapacitados, incluidos, entre otros, el uso de menores en la filmación de conductas sexuales explícitas, la distribución y exhibición de material que representa a menores en conductas sexualmente explícitas o el envío, distribución, exhibición, posesión, exhibición o transporte de material por parte de un padre, tutor o custodio, que represente a un niño involucrado en una conducta sexualmente explícita"
  },
  "page_Requirements_Employed_p22": {
    "value": "Compra o venta de un niño"
  },
  "page_Requirements_Employed_p23": {
    "value": "Delitos sexuales (incluidos, entre otros, incesto, abuso sexual o exhibicionismo)"
  },
  "page_Requirements_Employed_p24": {
    "value": "Los asistentes no serán aprobados ni utilizados para el empleo si son condenados por los siguientes delitos dentro de los plazos especificados"
  },
  "page_Requirements_Employed_p25": {
    "value": "Delitos graves relacionados con drogas (en los últimos 5 años)"
  },
  "page_Requirements_Employed_p26": {
    "value": "Delito grave de DUI (en los últimos 5 años)"
  },
  "page_Requirements_Employed_p27": {
    "value": "Para obtener más información sobre CDASS y los requisitos para los asistentes, comuníquese con"
  },
  "page_Requirements_Employed_p28": {
    "value": "CONSUMER DIRECT CARE NETWORK COLORADO"
  },
  "page_Requirements_Employed_p29": {
    "value": "7951 East Maplewood Avenue"
  },
  "page_Requirements_Employed_p30": {
    "value": "Suite 125"
  },
  "page_Requirements_Employed_p31": {
    "value": "Greenwood Village, CO 80111"
  },
  "page_Search_FilterBy": {
    "value": "Filtrado Por"
  },
  "title_Accounts": {
    "value": "Cuentas"
  },
  "title_Active": {
    "value": "Activo"
  },
  "title_Admin": {
    "value": "Administración"
  },
  "title_Agree": {
    "value": "Aceptar"
  },
  "title_Any": {
    "value": "Ninguno"
  },
  "title_Attendants": {
    "value": "Acomodadores"
  },
  "title_Back": {
    "value": "Atrás"
  },
  "title_Cancel": {
    "value": "Cancelar"
  },
  "title_Certifications": {
    "value": "Certificaciones"
  },
  "title_ChangeEmail": {
    "value": "Cambiar E-Mail"
  },
  "title_ChangePassword": {
    "value": "Cambia la Contraseña"
  },
  "title_City": {
    "value": "Ciudad"
  },
  "title_ClearFilters": {
    "value": "Borrar"
  },
  "title_Complete": {
    "value": "Completar"
  },
  "title_Confirm": {
    "value": "Confirmar"
  },
  "title_Contact": {
    "value": "Contacto"
  },
  "title_ContactCaregiver": {
    "value": "Contacte a este cuidador."
  },
  "title_Continue": {
    "value": "Seguir"
  },
  "title_DateOfBirth": {
    "value": "Fecha de Cumpleaños"
  },
  "title_DayAvailable": {
    "value": "Día Disponible"
  },
  "title_Delete": {
    "value": "Borrar"
  },
  "title_DeleteProfile": {
    "value": "Borrar Perfil"
  },
  "title_Distance": {
    "value": "Distancia (mi)"
  },
  "title_DistanceTravel": {
    "value": "Distancia máxima de viaje diario"
  },
  "title_Edit": {
    "value": "Editar"
  },
  "title_Email": {
    "value": "Correo Electrónico"
  },
  "title_YourEmail": {
    "value": "Tu Correo Electrónico"
  },
  "title_Employment": {
    "value": "Empleo"
  },
  "title_Experience": {
    "value": "Experiencia"
  },
  "title_False": {
    "value": "Falso"
  },
  "title_Fax": {
    "value": "Fax"
  },
  "title_FirstName": {
    "value": "Primer Nombre"
  },
  "title_Home": {
    "value": "Casa"
  },
  "title_HoursPerWeek": {
    "value": "h/sem"
  },
  "title_Language": {
    "value": "English"
  },
  "title_Languages": {
    "value": "Idiomas"
  },
  "title_LastInitial": {
    "value": "Último Inicial"
  },
  "title_Location": {
    "value": "Localización"
  },
  "title_Menu": {
    "value": "Menú"
  },
  "title_Message": {
    "value": "Mensaje"
  },
  "title_Miles": {
    "value": "Millas"
  },
  "title_More": {
    "value": "Búsqueda Avanzada"
  },
  "title_NoResults": {
    "value": "No Se Encontraron Asistentes"
  },
  "title_PageHelp": {
    "value": "Ayuda"
  },
  "title_Pets": {
    "value": "Mascotas"
  },
  "title_PersonalSummary": {
    "value": "Resumen Personal"
  },
  "title_Phone": {
    "value": "Teléfono"
  },
  "title_PleaseSelectAll": {
    "value": "Por favor seleccione todas las respuestas válidas"
  },
  "title_PreferredLanguages": {
    "value": "Idiomas Preferidos"
  },
  "title_Profile": {
    "value": "Perfile"
  },
  "title_ProfilePicture": {
    "value": "Foto de Perfil"
  },
  "title_ProfileStatus": {
    "value": "Estado del Perfil"
  },
  "title_Providers": {
    "value": "Proveedores"
  },
  "title_Register": {
    "value": "Registro"
  },
  "title_Resume": {
    "value": "Resumen"
  },
  "title_RESUME": {
    "value": "RESUMEN"
  },
  "title_Save": {
    "value": "Guardar"
  },
  "title_SaveChanges": {
    "value": "Guardar Cambios"
  },
  "title_Search": {
    "value": "Buscar"
  },
  "title_Security": {
    "value": "Seguridad"
  },
  "title_Select": {
    "value": "Seleccione"
  },
  "title_SENDMESSAGE": {
    "value": "ENVIAR MENSAJE"
  },
  "title_SendMessage": {
    "value": "Enviar Mensaje"
  },
  "title_ServicesProvided": {
    "value": "Servicios Prestados"
  },
  "title_SignIn": {
    "value": "Iniciar"
  },
  "title_SignOut": {
    "value": "Desconectar"
  },
  "title_SignUp": {
    "value": "Registrarse"
  },
  "title_Smoking": {
    "value": "De Fumar"
  },
  "title_Spam": {
    "value": "Correo no Deseado"
  },
  "title_State": {
    "value": "Estado"
  },
  "title_Status": {
    "value": "Estado"
  },
  "title_TotalWeeklyHours": {
    "value": "Total de Horas Semanales"
  },
  "title_TotalWeeklyWork": {
    "value": "Trabajo Semanal Total"
  },
  "title_True": {
    "value": "True"
  },
  "title_TravelLimit": {
    "value": "Límite de viaje"
  },
  "title_WARNING": {
    "value": "ADVERTENCIA"
  },
  "title_WeeklyHours": {
    "value": "Horas Semanales"
  },
  "title_Years": {
    "value": "Años"
  },
  "title_Zipcode": {
    "value": "Código Postal"
  },
  "card_view": {
    "value": "VER PERFIL"
  },
  "card_schedule": {
    "value": "Horario de Trabajo"
  },
  "card_rate": {
    "value": "horas/semana"
  },
  "Certified Nursing Assistant": {
    "value": "Auxiliar de enfermería certificado"
  },
  "CPR": {
    "value": "RCP"
  },
  "Licensed Practical Nurse": {
    "value": "Enfermera práctica licenciada"
  },
  "Medical Assistant": {
    "value": "Asistente medico"
  },
  "Nutrition": {
    "value": "Nutrición"
  },
  "Occupational Therapy": {
    "value": "Terapia ocupacional"
  },
  "Qualified Medication Administration Personnel": {
    "value": "Personal calificado para la administración de medicamentos"
  },
  "Registered Nurse": {
    "value": "Enfermera registrada"
  },
  "Hygiene & Infection Control": {
    "value": "Higiene y control de infecciones"
  },
  "Meal Preparation": {
    "value": "Preparación de alimentos"
  },
  "Physical Therapy": {
    "value": "Terapia física"
  },
  "Emergency & First Aid": {
    "value": "Emergencias y primeros auxilios"
  },
  "Bladder and Bowel Care": {
    "value": "Cuidados relacionados con la vejiga y los intestinos"
  },
  "Exercise/ROM": {
    "value": "Ejercicio/rango de movimiento"
  },
  "Health Maintenance": {
    "value": "Cuidado de la salud"
  },
  "Medication Administration": {
    "value": "Administración de medicamentos"
  },
  "Nail & Skin Care": {
    "value": "Cuidado de las uñas y la piel"
  },
  "Respiratory Care": {
    "value": "Cuidado respiratorio"
  },
  "Transfers & Use of lifts": {
    "value": "Traslados y levantamiento de peso"
  },
  "Wound Care": {
    "value": "Cuidado de heridas"
  },
  "Homemaking/Cleaning": {
    "value": "Tareas de hogar/limpieza"
  },
  "Personal Care Services": {
    "value": "Servicios de cuidado personal"
  },
  "Shopping": {
    "value": "Ir de compras"
  },
  "Current CDASS Attendant": {
    "value": "Asistente actual de los CDASS"
  },
  "Have Lifting Restrictions": {
    "value": "Tiene restricciones para levantar peso"
  },
  "Non-Smoker": {
    "value": "No fuma"
  },
  "Pets/Service Animals OK": {
    "value": "No tiene problemas con mascotas/animales de servicio"
  },
  "Willing to learn": {
    "value": "Disposición para aprender"
  },
  "English": {
    "value": "Inglés"
  },
  "Spanish": {
    "value": "Español"
  },
  "Child": {
    "value": "Menor"
  },
  "Legal Representative": {
    "value": "Representante legal"
  },
  "No Relationship": {
    "value": "Sin parentesco"
  },
  "Other": {
    "value": "Otro"
  },
  "Paid Guardian Conservator": {
    "value": "Tutor custodio remunerado"
  },
  "Parent": {
    "value": "Padre"
  },
  "Sibling": {
    "value": "Hermano"
  },
  "Spouse": {
    "value": "Cónyuge"
  },
  "Unpaid Guardian Conservator": {
    "value": "Tutor custodio no remunerado"
  },
  "Today": {
    "value": "Este Dia"
  },
  "One Week": {
    "value": "Una Semana"
  },
  "Two Weeks": {
    "value": "Dos Semanas"
  },
  "actions_okay": {
    "value": "OK"
  },
  "footer_tagline": {
    "value": "CADA VIDA. CADA MOMENTO. CADA DÍA."
  },
  "footer_disclaimer_title": {
    "value": "El Directorio de Proveedores ayuda a las personas a encontrar cuidadores. Consumer Direct Care Network no:"
  },
  "footer_disclaimer_list1": {
    "value": "revisa ni evalúa los perfiles en el Directorio de Proveedores"
  },
  "footer_disclaimer_list2": {
    "value": "asume ninguna responsabilidad por la exactitud o confiabilidad de la información proporcionada por los cuidadores."
  },
  "breadcrumb_CreateProfile": {
    "value": "Crear Perfil"
  },
  "breadcrumb_EditProfile": {
    "value": "Editar Perfil"
  },
  "breadcrumb_Home": {
    "value": "Inicio"
  },
  "breadcrumb_SearchResults": {
    "value": "Resultados"
  },
  "pager_itemsPerPage": {
    "value": "elementos por página"
  },
  "pager_items": {
    "value": "elementos"
  }
}
